import dataConstants from "../../constants/dataConstants";
import PhysicianFieldProps from "../../services/models/formModels/physicianFieldProps.model";
import useSuffixAndSpecialty from "../../services/utils/custom hooks/useSuffixAndSpecialty";
import FieldRenderer from "../global/forms/FieldRenderer";

function PhysicianFields({
  touched,
  errors,
  handleChange,
  handleBlur,
  isSignUpFlow,
  values,
  setFieldValue,
  getFieldMeta,
}: PhysicianFieldProps): JSX.Element {
  return (
    <FieldRenderer
      fields={dataConstants.physicianPhysicianFields
        .filter((field) => {
          if (isSignUpFlow) {
            return (
              (field.name?.includes("profileImage") ||
                field?.name?.includes("fax") ||
                field?.name?.includes("phone")) === false
            );
          }
          return true;
        })
        .map((field, index) => ({
          ...field,
          key: `${index}${field.name}`,
          setFieldValue,
          values,
          getFieldMeta,
          labelInfo: {
            ...field.labelInfo,
            inputId: isSignUpFlow ? `user.${field.name}` : field.name,
          },
          errors: errors,
          roundedInput: true,
          touched: touched,
          onChange: handleChange,

          onBlur: handleBlur,
          value: isSignUpFlow
            ? values?.user?.[!!field.name ? field.name : ""]
            : values?.[!!field?.name ? field.name : ""],
          name: isSignUpFlow ? `user.${field.name}` : field.name,
        }))}
    />
  );
}

export default PhysicianFields;
